import {PartnerClientVO, PartnerClientListVO} from './partner-client.interfaces';
import {All} from './partner-client.actions';
import {CrudAll, crudInitialState, CrudReducer, CrudState, createCrudDefinition} from '@abydos-angular/store';

export interface PartnerClientState extends CrudState<PartnerClientVO> {
}

export const initialState: PartnerClientState = {
    ...crudInitialState
};

export const partnerClientFeatureName = 'partnerClient';

export const partnerClientDefinition = createCrudDefinition<PartnerClientVO, PartnerClientListVO>(partnerClientFeatureName , initialState);
/*
Ez egy minta sub definíció, ha a modulban 1-nél több CRUD-ra van szükség
export const partnerClientSubDefinition = createCrudDefinition<PartnerClientSubVO, PartnerClientSubListVO>(partnerClientDefinition, crudInitialState, 'partnerClientSub');
 */

export function partnerClientReducer<T, S>(state: PartnerClientState, action: All): PartnerClientState {
    switch (action.type) {
        default: {
            return CrudReducer(partnerClientDefinition, state, action as CrudAll<T, S>) as PartnerClientState;
        }
    }
}
